<app-page-content>
  <ng-container title>{{ "Customers.Receivers.AddNewReceiver" | translate }}</ng-container>

  <app-state-section content [state]="sectionState" [errorStateLabel]="'ErrorMessages.ErrorHappened' | translate">
    <mat-card class="card" content>
      <mat-card-content class="card-content" *ngIf="form">
        <div class="basic-info">
          <h3 class="title">{{ "Customers.Receivers.BasicInformation" | translate }}</h3>

          <div class="form-container">
            <form class="form-group flex column justify-flex-start align-flex-start" [formGroup]="form">
              <!-- company name -->
              <div class="flex column form-control full-width">
                <mat-label>{{ "Inputs.CompanyName" | translate }}</mat-label>
                <mat-form-field appearance="outline">
                  <input matInput type="text" [placeholder]="'Placeholder.EnterCompanyName' | translate" formControlName="companyName" />
                  <mat-error
                    *ngIf="
                      form.invalid &&
                      form.get('companyName').touched &&
                      form.get('companyName').hasError('required')
                    "
                  >
                    {{ "ErrorMessages.Required" | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div
                style="width: 100%"
                formArrayName="contacts"
                *ngFor="
                  let contact of form.get('contacts')['controls'];
                  let i = index
                "
              >
                <div [formGroupName]="i">
                  <div class="contact-fields flex row">
                    <!-- first name -->
                    <div class="flex column partial-width">
                      <mat-label>{{ "Inputs.FirstName" | translate }}</mat-label>
                      <mat-form-field appearance="outline">
                        <input
                          matInput
                          type="text"
                          [placeholder]="
                            'Placeholder.EnterFirstName' | translate
                          "
                          formControlName="firstName"
                        />
                        <mat-error
                          *ngIf="
                            contact.invalid &&
                            contact.get('firstName').touched &&
                            contact.get('firstName').hasError('required')
                          "
                        >
                          {{ "ErrorMessages.Required" | translate }}
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <!-- last name -->
                    <div class="flex column partial-width">
                      <mat-label>{{ "Inputs.LastName" | translate }}</mat-label>
                      <mat-form-field appearance="outline">
                        <input
                          matInput
                          type="text"
                          [placeholder]="
                            'Placeholder.EnterLastName' | translate
                          "
                          formControlName="lastName"
                        />
                        <mat-error
                          *ngIf="
                            contact.invalid &&
                            contact.get('lastName').touched &&
                            contact.get('lastName').hasError('required')
                          "
                        >
                          {{ "ErrorMessages.Required" | translate }}
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <!-- email -->
                    <div class="form-control flex column partial-width">
                      <mat-label>{{ "Inputs.Email" | translate }}</mat-label>
                      <mat-form-field appearance="outline">
                        <input matInput type="text" [placeholder]="'Placeholder.Email' | translate" formControlName="email" />
                        <mat-error
                          *ngIf="
                            contact.invalid &&
                            contact.get('email').touched &&
                            contact.get('email').hasError('invalidEmail')
                          "
                        >
                          {{ "ErrorMessages.InvalidEmail" | translate }}
                        </mat-error>

                        <mat-error
                          *ngIf="
                            contact.invalid &&
                            contact.get('email').touched &&
                            contact.get('email').hasError('maxlength')
                          "
                        >
                          {{ "ErrorMessages.InValidMaxLength20" | translate }}
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <!-- mobile -->
                    <div class="form-control flex column partial-width">
                      <mat-label>{{ "Inputs.MobileNumber" | translate }}</mat-label>

                      <div class="mobile-group flex row">
                        <!-- code -->
                        <mat-form-field class="select-options" appearance="outline">
                          <mat-select formControlName="countryCode">
                            <mat-option *ngFor="let country of countries" [value]="country.phoneKey" (click)="selectedCountryCode = country">
                              {{ country.phoneKey }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>

                        <mat-form-field class="input-field" appearance="outline">
                          <input matInput type="text" [placeholder]="'Placeholder.MobileNumber' | translate" formControlName="mobile" />
                          <mat-error
                            *ngIf="
                            contact.invalid &&
                              contact.get('mobile').touched &&
                              (contact.get('mobile').hasError('whitespace') ||
                              contact.get('mobile').hasError('invalidPhoneNumber'))"
                          >
                            {{ "ErrorMessages.InvalidPhone" | translate }}
                          </mat-error>
                          <mat-error
                            *ngIf="
                            contact.invalid &&
                            contact.get('mobile').touched &&
                            (contact.get('mobile').hasError('invalidPhoneNumberLength'))"
                          >
                            {{ "ErrorMessages.InValidMobileLength" | translate: {length: MobileLengthPerCode[contact.get('countryCode').value]} }}
                          </mat-error>
                          <mat-error
                            *ngIf="
                            contact.invalid &&
                            contact.get('mobile').touched &&
                            (contact.get('mobile').hasError('invalidPhoneNumberType'))"
                          >
                            {{ "ErrorMessages.invalidPhoneNumberType" | translate }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>

            <div class="add-contact-btn">
              <img src="../../../../../assets/images/add.svg" />
              <p (click)="addContact()">{{ "Buttons.AddAnotherContactPerson" | translate }}</p>
            </div>
          </div>
        </div>

        <div class="location">
          <app-locations
            [enableLocationsView]="true"
            [title]="'Customers.Receivers.ReceiverLocation' | translate "
            [item]="addedReceiver"
            [type]="LocationType.Receiver"
            (locationId)="getLocationIds($event)"
          ></app-locations>
          <!-- [selectedMapLocation]="selectedMapLocation" -->
        </div>

        <div class="action flex row">
          <button mat-raised-button class="btn-secondary btn" (click)="onCancelButtonClicked()">{{ "Buttons.Cancel" | translate }}</button>

          <button mat-raised-button class="btn-primary btn" (click)="onSaveButtonClicked()" [disabled]="form.invalid || !locationIds.length">
            {{ "Buttons.Save" | translate }}
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </app-state-section>
</app-page-content>
